export default "__VITE_ASSET__3GWRE7nG__"